




















import { defineComponent } from '@vue/composition-api';
import qrCodePreview from '@/components/common/qr-code-preview/index.vue';

const name = 'ttam-instant-message-app-check';
export default defineComponent({
  name,
  components: {
    qrCodePreview,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: '',
    },
    desc: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    return {
      name,
    };
  },
});
